import _ from 'lodash';
import {ActionTypes} from './../../cc-imports'

const initialState = {
    leagueId : undefined,
    matchId : undefined
};

const NavigationReducers = (state = initialState, action={}) => {

    switch (action.type){
        case ActionTypes.LEAGUES:
            return {...state ,...{matchId : action.payload.matchId}}
        default:
            return state || initialState
    }


};

export default  NavigationReducers;


// WEBPACK FOOTER //
// ./src/app/data/reducers/CCNavigationReducers.js